import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import {
    Checkbox, 
    FormControlLabel,
    Typography,
    Grid,
    TextField,
} from '@mui/material';
import { connect } from 'react-redux';
import { useForm } from 'react-hook-form';
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { EditorState, convertToRaw, RichUtils  } from 'draft-js';
// import htmlToDraft from 'html-to-draftjs';
import draftToHtml from 'draftjs-to-html';

import * as headerActions from '../../../store/actions/header';
import * as Styled from '../../../components/styled-components/Campaign';

import appConfig from '../../../config/appConfig';
import RadioButtonGroup from '../../../components/RadioButtonGroup';
import ButtonComponent from '../../../components/ButtonGroup';


const ErrorStyle = {
    color: "red",
    display: 'flex',
    marginTop: '5px'
}

const textboxCss = {
    border: `1px solid ${appConfig.colors.darkblue}`,
    borderRadius: "4px",
    outline: "none",
    '&.MuiFormControl-root': {
        margin: "0"
    },
    '&.MuiTextField-root': {
        backgroundColor: '#fff'
    },
    '& .MuiInputBase-input': {
        backgroundColor: '#fff',
        fontSize: 16,
        fontFamily: appConfig.fontfamily,
        padding: "10px 14px",
        borderRadius: "4px",
        outline: "none",

    },
    '& .MuiOutlinedInput-root': {
        padding: '0',
    }
};

const userDetails = JSON.parse(window.sessionStorage.getItem("userInfo"));

const CreateHeaderConfiguration = ({ showHeaderConfigurations, headerConfigs, createHeader }) => {
    const filters = ['EN', 'ES', 'PT', 'VI', 'HT', 'ZH'];
    const { register, handleSubmit, formState: { errors } } = useForm();
    const [isDefaultConfig, setIsDefaultConfig] = useState("No");
    const [editorStateHeader, setEditorStateHeader] = useState(
        { 
            'en' : EditorState.createEmpty(), 'es' : EditorState.createEmpty(),
            'pt' : EditorState.createEmpty(), 'vi' : EditorState.createEmpty(),
            'ht' : EditorState.createEmpty(), 'zh' : EditorState.createEmpty()
        }
    );
    const [contentHeader, setContentHeader] = useState();
    const editorRefHeader = useRef();

    const [assignEnglishToOthers, setAssignEnglishToOthers] = useState(false);
    const [selectedLang, setSelectedLang] = useState("EN");

    useEffect(() => {
        if(Object.keys(headerConfigs?.createHeaderData).length > 0) {
            showHeaderConfigurations();
        }
    }, [headerConfigs?.createHeaderData])

    useEffect(() => {
        if(assignEnglishToOthers) {
            let tempEditorState = editorStateHeader;
            let tempContentHeader = contentHeader;
            filters.forEach((lang)=> {
                tempEditorState = {...tempEditorState, [lang.toLowerCase()]: tempEditorState.en};
                tempContentHeader = {...tempContentHeader, [lang.toLowerCase()] : tempContentHeader.en};
            }
            );
            setEditorStateHeader(tempEditorState);
            setContentHeader(tempContentHeader);
        }
    }, [assignEnglishToOthers])

    const handleEditorChangeHeader = (state) => {
        setEditorStateHeader({...editorStateHeader, [selectedLang.toLowerCase()]: state});
        setContentHeader( {...contentHeader, [selectedLang.toLowerCase()] : `<div>${draftToHtml(convertToRaw(editorStateHeader[selectedLang.toLowerCase()].getCurrentContent()))}</div>`});
    }

     const filterHandleChange = (e) => {
        if (e.target.textContent) {
            setSelectedLang(e.target.textContent);
        }
    }

    const uploadFileCallback = (file) => {
        return new Promise(
            (resolve) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.addEventListener('load', () => {
                    resolve({ data: { link: reader.result } });
                });
            }
        );
    }

    const onSubmit = (data) => {
        const tempHeaderConfig ={
            name: data.name,
            code: data.code,
            defaultConfigFlag: isDefaultConfig === 'Yes',
            sectionConfiguration: contentHeader.en,
            sectionType: 'HEADER',
            translations: [                
                {
                    languageCode: 'en',
                    content: contentHeader.en || '<p></p>',
                    createdBy: userDetails?.emailId,
                    modifiedBy: userDetails?.emailId
                },
                {
                    languageCode: 'es',
                    content: contentHeader.es || '<p></p>',
                    createdBy: userDetails?.emailId,
                    modifiedBy: userDetails?.emailId
                },
                {
                    languageCode: 'pt',
                    content: contentHeader.pt || '<p></p>',
                    createdBy: userDetails?.emailId,
                    modifiedBy: userDetails?.emailId
                },
                {
                    languageCode: 'ht',
                    content: contentHeader.ht || '<p></p>',
                    createdBy: userDetails?.emailId,
                    modifiedBy: userDetails?.emailId
                },
                {
                    languageCode: 'vi',
                    content: contentHeader.vi || '<p></p>',
                    createdBy: userDetails?.emailId,
                    modifiedBy: userDetails?.emailId
                },
                {
                    languageCode: 'zh',
                    content: contentHeader.zh || '<p></p>',
                    createdBy: userDetails?.emailId,
                    modifiedBy: userDetails?.emailId
                }
            ]
        }        
        createHeader(tempHeaderConfig);
    }

    const handleContentChange = () => {
        setIsDefaultConfig(isDefaultConfig  === 'Yes' ? 'No' : 'Yes');
    }

    return (
        <div>
            <Grid container spacing={2}>
                <Grid item xs={6} sm={6} xl={6} lg={6} md={6}>
                    <h3><b>Create Header Configuration</b></h3>
                </Grid>
                <Grid item xs={6} xl={6} lg={6} md={6}>
                    <div className='text-align-right'>
                        <Styled.CampaignButton
                            className='text-trans-none'
                            variant="contained"
                            onClick={showHeaderConfigurations}
                        >
                            Header Configurations
                        </Styled.CampaignButton>
                    </div>
                </Grid>
            </Grid>
            <hr className='blue-border' />
            <form onSubmit={handleSubmit(onSubmit)}>
                <Grid container spacing={2}>
                    <Grid item md={7} xl={7} lg={7} xs={12} sm={12}>
                        <div >
                            <Typography component="p" sx={{ mb: 1 }}>Header Configuration Name (Required)</Typography>
                            <TextField
                                {...register('name', { required: true, maxLength: 79 })}
                                margin="normal"
                                id="name"
                                sx={textboxCss}
                                fullWidth
                                inputProps={{ "aria-label": "template name" }}
                            />
                        </div>
                        {errors?.name?.type === "required" && <span style={ErrorStyle}>Please enter Header Configuration name.</span>}
                        {errors?.name?.type === "maxLength" && (<span style={ErrorStyle}>Header Configuration name cannot exceed 80 characters</span>)}
                    </Grid>

                    <Grid item md={7} xl={7} lg={7} sm={12}>
                        <div >
                            <Typography component="p" sx={{ mb: 1 }} className="inline-blk">Header Configuration Code (Required)</Typography>
                            <Typography component="p" sx={{ mb: 1 }} className="inline-blk flt-r">Must be 6 characters</Typography>
                            <TextField
                                {...register('code', { required: true, pattern: /^[A-Za-z0-9 ]+$/, maxLength: 6, minLength: 6 })}
                                margin="normal"
                                id="code"
                                sx={textboxCss}
                                fullWidth
                                inputProps={{ "aria-label": "template code" }}
                            />
                        </div>
                        {errors?.code?.type === "required" && <span style={ErrorStyle}>Please enter Header Configuration code.</span>}
                        {errors?.code?.type === "pattern" && (<span style={ErrorStyle}>Special characters not allowed.</span>)}
                        {errors?.code?.type === "maxLength" && (<span style={ErrorStyle}>Header Configuration code must be 6 characters</span>)}
                        {errors?.code?.type === "minLength" && (<span style={ErrorStyle}>Header Configuration code must be 6 characters</span>)}
                    </Grid>
                    <Grid item md={7} xl={7} lg={7} sm={12}>
                        <Typography component="p" sx={{ mb: 1 }} className="inline-blk">Set as default Header Configuration?</Typography>
                        <Typography component="p" sx={{ mb: 1, fontSize: '14px' }} className="inline-blk">(Overrides current default Header Configuration)</Typography>
                            <RadioButtonGroup
                                className={['create-using-account-radio', isDefaultConfig].join(' ')}
                                header=' '
                                value={isDefaultConfig}
                                labels={['Yes', 'No']}
                                handleChange={handleContentChange}
                            />
                    </Grid>
                    <Grid item md={12} xl={12} lg={12} sm={12}>
                        <Typography component="p" className="inline-blk">Header Content</Typography>
                        <br/>
                        <br/>
                        <FormControlLabel
                            key='headerSetEnglish'
                            sx={[assignEnglishToOthers ? appConfig.checkboxStyleChecked : appConfig.checkboxStyle, appConfig.wFit]}
                            control={
                                <Checkbox
                                    sx={assignEnglishToOthers ? { color: appConfig.colors.white } : { color: appConfig.colors.darkblue }}
                                    checked={assignEnglishToOthers}
                                    onChange={() => { setAssignEnglishToOthers(!assignEnglishToOthers) }}
                                />
                            }
                            label='Apply English Header content for other languages'
                        />
                        <div className='flt-r'><ButtonComponent filters={filters} activeFilter={selectedLang} onClick={filterHandleChange} /></div>
                    </Grid>
                    <Grid item md={12} xl={12} lg={12} sm={12}>
                        <Editor
                            tabIndex={0}
                            handlePastedText={() => false}
                            ref={editorRefHeader}
                            editorState={editorStateHeader[selectedLang.toLowerCase()]}
                            toolbar={
                                {
                                    image: { urlEnabled: true, uploadEnabled: true, previewImage: true, inputAccept: 'image/gif,image/jpeg,image/jpg,image/png,image/svg', uploadCallback: uploadFileCallback },
                                    fontFamily: {
                                        options: ['Arial', 'Georgia', 'Impact', 'Tahoma', 'Times New Roman', 'Verdana', 'Source Sans Pro'],
                                    },
                                }}
                            editorStyle={{ border: "1px solid #ccc", height: "200px", padding: "15px" }}
                            toolbarStyle={{ border: "1px solid #ccc", paddingRight: "10%" }}
                            onEditorStateChange={(state) => { handleEditorChangeHeader(state) }}
                            handleKeyCommand={(command) => {
                            const newState = RichUtils.handleKeyCommand(editorStateHeader[selectedLang.toLowerCase()], command)                                
                                if (newState) {
                                    handleEditorChangeHeader(newState)
                                    return true;
                                }
                                return false;
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={12} xl={12} lg={12} md={12}>
                        <hr className='blue-border' />
                    </Grid>
                    <Grid container spacing={1} sx={{ marginLeft: "10px" }}>
                        <Grid item xs={12} sm={4} xl={1.5} lg={1.5} md={1.5}>
                            <Styled.CancelButton
                                variant="outlined"
                                sx={{ mt: 3, fontFamily: appConfig.fontfamily, textTransform: 'capitalize', width: '100%', height: "50px" }}
                                onClick={showHeaderConfigurations}
                            >
                                Cancel
                            </Styled.CancelButton>
                        </Grid>
                        <Grid item xs={12} sm={8} xl={5.6} lg={5.6} md={5.6}>
                            <Styled.CampaignButton
                                type='submit'
                                variant="contained"
                                sx={{ mt: 3, fontFamily: appConfig.fontfamily, textTransform: 'capitalize', width: '100%', height: "50px" }}
                            >
                                Create
                            </Styled.CampaignButton>
                        </Grid>
                    </Grid>
                </Grid>
            </form>
        </div>
    );
}

CreateHeaderConfiguration.propTypes = {
    showHeaderConfigurations: PropTypes.func.isRequired,
    headerConfigs: PropTypes.object.isRequired,
    createHeader: PropTypes.func.isRequired,
}

const mapStateToProps = (state) => ({headerConfigs: state.header})

const mapDispatchToProps = (dispatch) => {
    return {
        createHeader:(data) => dispatch(headerActions.createHeader(data))    
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateHeaderConfiguration);